// import { downgradeInjectable } from "@angular/upgrade/static";
// import { IAngularStatic } from "angular";
import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { Observable } from "rxjs";
import * as lodash from "lodash";

import { BASE_URLS, DISCOVERY_SERVICES_URLS } from "@tci/common";
import { NgWindowRefService } from "./ng-window-ref.service";

// declare var angular: IAngularStatic;

@Injectable()
export class NgWsDiscoveryService {
  private discoveryServices = lodash.cloneDeep(DISCOVERY_SERVICES_URLS);

  constructor(
    private http: Http,
    private windowRef: NgWindowRefService
  ) { }

  public createEnableEndpointVisibility(): Observable<boolean> {
    return this.webServerRequest(DISCOVERY_SERVICES_URLS.ENABLE_ENDPOINT_VISIBILITY, "enabled");
  }

  public createEnableTscSignupForm(): Observable<boolean> {
    return this.webServerRequest(DISCOVERY_SERVICES_URLS.ENABLE_TSC_SIGNUP_FORM, "enabled");
  }

  public getDomainServiceUrl(): Observable<string> {
    return this.webServerRequest(DISCOVERY_SERVICES_URLS.DOMAIN_SERVER, "url");
  }

  public getMGSServiceUrl(): Observable<string> {
    return this.webServerRequest(DISCOVERY_SERVICES_URLS.MGS, "url");
  }

  public getApiMockServiceUrl(): Observable<string> {
    return this.webServerRequest(DISCOVERY_SERVICES_URLS.API_MOCK, "url");
  }

  public getApiModelerServiceUrl(): Observable<string> {
    return this.webServerRequest(DISCOVERY_SERVICES_URLS.API_MODELER, "url");
  }

  public getAppManagerServiceUrl(): Observable<string> {
    return this.webServerRequest(DISCOVERY_SERVICES_URLS.APP_MANAGER, "url");
  }

  public getBuildServerServiceUrl(): Observable<string> {
    return this.webServerRequest(DISCOVERY_SERVICES_URLS.BUILD_SERVER, "url");
  }

  public getApiOrchestratorServiceUrl(): Observable<string> {
    return this.webServerRequest(DISCOVERY_SERVICES_URLS.API_ORCHESTRATOR, "url");
  }

  public getUnityApiProxyServiceUrl(): Observable<string> {
    return this.webServerRequest(DISCOVERY_SERVICES_URLS.UNITY_API_PROXY, "url");
  }

  public getIndexUrl(): Observable<string> {
    return this.webServerRequest(DISCOVERY_SERVICES_URLS.INDEX_URL, "url");
  }

  public getRegisterUrl(): Observable<string> {
    return this.webServerRequest(DISCOVERY_SERVICES_URLS.REGISTER_URL, "url");
  }

  public getRedirectionTime(): Observable<number> {
    return this.webServerRequest(DISCOVERY_SERVICES_URLS.REDIRECTION_TIME, "time");
  }

  public getTciTenantId(): Observable<string> {
    return this.webServerRequest(DISCOVERY_SERVICES_URLS.TCI_TENANT_ID, "id");
  }

  public getLoginServiceUrl(): Observable<string> {
    return this.webServerRequest(DISCOVERY_SERVICES_URLS.LOGIN, "url");
  }

  public getMasheryServiceUrl(): Observable<string> {
    return this.webServerRequest(DISCOVERY_SERVICES_URLS.MASHERY_SERVER, "url");
  }

  public getEnableTSCIntegrationVar(): Observable<boolean> {
    return this.webServerRequest(DISCOVERY_SERVICES_URLS.ENABLE_TSC_INTEGRATION, "enabled");
  }

  public getTscSignupUrl(): Observable<string> {
    return this.webServerRequest(DISCOVERY_SERVICES_URLS.TSC_SIGNUP, "url");
  }

  public getIdentityManagementServiceUrl(): Observable<string> {
    return this.webServerRequest(DISCOVERY_SERVICES_URLS.IDENTITY_MANAGEMENT, "url");
  }

  public getLogDownloadSizeLimit(): Observable<number> {
    return this.webServerRequest(DISCOVERY_SERVICES_URLS.LOG_DOWNLOAD_SIZE_LIMIT, "size");
  }

  public getRegisterUserUrl(): Observable<string> {
    const location = this.windowRef.nativeWindow.location;

    return this
      .webServerRequest(DISCOVERY_SERVICES_URLS.REGISTER_USER, "url")
      .map(value => `${location.protocol}//${location.hostname}${value}`);
  }

  private webServerRequest(service: string, type: string): Observable<any> {
    if (this.discoveryServices[service]) {
      return Observable.of(this.discoveryServices[service]);
    } else {
      return this
        .http
        .get(`${BASE_URLS.WEBSERVER}/services/${service}`)
        .map(value => {
          this.discoveryServices[service] = value.json()[type];
          return value.json()[type];
        }, this);
    }
  }
}

// if (typeof angular !== "undefined") {
//   angular
//     .module("main")
//     .factory("troposCommonServiceRestfulAPIWSDiscovery", downgradeInjectable(NgWsDiscoveryService) as any);
// }
